export class Translate {
    languages;
    translations;
    logError;
    constructor(languages, translations, logError) {
        this.languages = languages;
        this.translations = translations;
        this.logError = logError;
    }
    getTranslation(translations, language, key) {
        if (!translations.hasOwnProperty(key)) {
            this.logError(Error(`Key ${key} not found in translations`));
            return key;
        }
        const result = translations[key];
        if (!result.hasOwnProperty(language)) {
            this.logError(Error(`Key ${key} not found in language: ${language}`));
            return key;
        }
        return result[language];
    }
    interpolateValue(params, string) {
        const logError = this.logError;
        return string.replace(/#{([^\\}]+)}/g, function (match, key) {
            if (typeof params[key] === "undefined" || params[key] === null) {
                logError(Error(`Param missing in ${JSON.stringify(params)} for key: ${key}`));
                return match;
            }
            const returnValue = params[key];
            return typeof returnValue === "number"
                ? returnValue.toString()
                : returnValue;
        });
    }
    interpolateNumeral(params, string) {
        const logError = this.logError;
        return string.replace(/N{([^\\}]+)}/g, function (match, key) {
            const [numeral, single, multiple] = key.split(",");
            if (typeof params[numeral] === "undefined" || params[numeral] === null) {
                logError(Error(`Param missing in ${JSON.stringify(params)} for numeral: ${numeral}`));
                return match;
            }
            const param = params[numeral];
            const paramAsNumber = typeof param === "string" ? parseInt(param) : param;
            if (paramAsNumber !== 1) {
                return multiple;
            }
            return single;
        });
    }
    interpolate(string, params) {
        const valuesInterpolated = this.interpolateValue(params, string);
        const numeralsInterpolated = this.interpolateNumeral(params, valuesInterpolated);
        return numeralsInterpolated;
    }
    translate(language, key, params = {}, providedLanguages = {}, providedLanguageNames = []) {
        const languages = [...this.languages, ...providedLanguageNames];
        const translations = { ...this.translations, ...providedLanguages };
        if (!languages.includes(language)) {
            throw new Error(`Invalid language: ${language}. Valid languages: ${languages}`);
        }
        const translatedText = this.getTranslation(translations, language, key);
        return this.interpolate(translatedText, params);
    }
}
